module.exports = __webpack_public_path__ + "static/media/v18.a3e50a8d.mp4";